import { createApp } from 'vue'
import App from './App.vue'

const vm  = createApp(App).mount('#app')


// Expose the Vue instance globally
window.vueApp = vm;